import {BaseFormModel} from './base-form-model';
import {MenuTaxLabel} from './menu-tax-label';

export class MembershipProgram extends BaseFormModel<MembershipProgram> {
    id: number;
    name: string;
    description: string;
    status: string;
    amount: number;
    durationPart: string;
    durationCount: number;
    autoRenewal: boolean;
    lifetime: boolean;
    tokens: number;
    tokensExpire: boolean;
    taxTokenPayments: boolean;
    sortOrder: number;
    feeStructure: string;
    taxLabels: MenuTaxLabel[];
    color: string;
    contrastColor: string;
    continuousRenewalDate: boolean;
    expirationEmailDuration: string;
    expirationEmailDurationCount: number;
    sendLowTokenEmail: boolean;
    lowTokenEmailThreshold: number;
}
